import $ from 'jquery';
import { SCENE_EVENTS } from '../MVC/Model';
import { tourExists } from '../../socket/socketHelper';
import { tourID } from '../../setScene';

const header = `
<div class="people-header" id="people-header">
    <div class="people-header-left-inner" data-lang="people-text">
      Invite to tour
    </div>
    <div class="people-header-right-inner">
      <span class="material-icons clickable" id="userToTourInviteButton">close</span>
    </div>
  </div>
`

const invitableItem = (item) => `
    <div class="row invite">
        <div class="invitable-user-info-wrapper">
            <div class="invitable-user-item-image">
                <img src="${item.userAvatarUrl}" alt="${item.userName}">
            </div>
            <p>${item.userName}</p>
            <div id="invite-raised-hand-${item.userId}" >

            </div>
        </div>
        <button class="invite-btn buttn primary" data-userid="${item.userId}">Invite</button>
    </div>
`;
const invitedItem = (item) => `
    <div class="row invited">
        <div class="invitable-user-info-wrapper">
            <div class="invitable-user-item-image">
                <img src="${item.userAvatarUrl}" alt="${item.userName}">
            </div>
            <p>${item.userName}</p>
        </div>
        Invited
    </div>
`;

const openButton = () => `
    <div id="openAddUsersToTourButton">
        <div class="open-user-selector-wrapper">
            <span class="material-icons md-26 clickable">person_add</span>
              <span class="tooltip" data-lang="invite-tour-user-as-guest">Invite guests</span>
        </div>
    </div>
`;
export default class UserSelectorWithButton {
  constructor({ list, container, model, socket }) {
    this.items = list || [];
    this.model = model;
    this.socket = socket;
    this.invite = [...this.items];
    this.invited = [];
    this.usersNotInStreamsMapped = [];
    this.header = $(header);
    this.wrapper = $(`<div class="user-selector-button" >${this.header}</div>`);
    this.container = container;
    this.isOpened = false;
    this.openButtonWrapper = $('<div class="open-add-users-wrapper" />');
    this.openButton = $(openButton());
    this.closeButton = this.wrapper.find("#userToTourInviteButton");

    this.openButton.on("click", () => {
      this.isOpened ? this.close() : this.open();
    });
    this.closeButton.on("click", () => {
      this.close();
    });

    this.container.append(this.openButtonWrapper);
    $(document.body).append(this.wrapper);
    this.openButtonWrapper.append(this.openButton);

    this.model.addEventListener(SCENE_EVENTS.NAVBAR_ITEM_CLICKED, () => {
      this.close();
    });

    this.model.addEventListener(SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA, () => {
      const tourStarted = tourExists(tourID, this.model.tourData);
      if (this.isOpened && tourStarted) {
        if (tourStarted.users) {
          this.updateUserList(this.socket.filterBySocketIds(tourStarted.users));
        }
        if (tourStarted.raisedHands) {
          const raisedHandUsers = this.socket.filterBySocketIds(tourStarted.raisedHands);
          raisedHandUsers.forEach(socketItem => {
            $(`#invite-raised-hand-${socketItem.userId}`).append($('<span class="material-icons-outlined">back_hand</span>'));
          });
        }
      }
    });

    this.close();
  }

  open() {
    this.isOpened = true;

    // Reset the invited list
    this.invited = [];

    const tourStarted = tourExists(tourID, this.model.tourData);

    if (tourStarted) {
      if (tourStarted.users) {
        const allUsers = tourStarted.users;
        const streamUsers = Object.keys(tourStarted.streams);

        const usersNotInStreams = allUsers.filter(user => !streamUsers.includes(user));

        // Map users to socket data
        this.usersNotInStreamsMapped = usersNotInStreams.map(user => {
          return this.model.socket.getUserBySocketId(user);
        }).filter(Boolean); // Remove any undefined entries

        // Update the invite list based on users not in streams
        this.invite = [...this.usersNotInStreamsMapped];
      }
    }

    this.renderItems();
    this.wrapper.show();

    if (tourStarted && tourStarted.raisedHands) {
      const raisedHandUsers = this.socket.filterBySocketIds(tourStarted.raisedHands);
      raisedHandUsers.forEach(socketItem => {
        $(`#invite-raised-hand-${socketItem.userId}`).append($('<span class="material-icons-outlined">back_hand</span>'));
      });
    }
  }

  close() {
    this.wrapper.empty();
    this.wrapper.hide();
    this.isOpened = false;
  }

  updateUserList(newUserData) {
    if (this.isOpened) {
      const invitedUserIds = new Set(this.invited.map(user => user.userId));
      const currentInviteUserIds = new Set(this.invite.map(user => user.userId));
      const filteredNewUsers = newUserData.filter(user =>
        !invitedUserIds.has(user.userId) && !currentInviteUserIds.has(user.userId)
      );
      this.invite = [...filteredNewUsers];
      this.renderItems();
    }
  }

  moveToInvited(userId, buttonElement) {
    const userIdStr = userId.toString();
    const userIndex = this.invite.findIndex(item => item.userId.toString() === userIdStr);

    if (userIndex > -1) {
      const user = this.invite[userIndex];
      this.invited.push(user);
      this.invite.splice(userIndex, 1);
      $(buttonElement).addClass('disabled').prop('disabled', true);
      this.renderItems();
    }
  }

  renderItems() {
    this.wrapper.html(
      this.invite.map(item => invitableItem(item)).join('') +
      this.invited.map(item => invitedItem(item)).join('')
    );
    this.wrapper.prepend($(header));
    this.attachEventHandlers();
  }

  attachEventHandlers() {
    this.wrapper.find('.invite-btn').off('click').on('click', (event) => {
      const userId = $(event.currentTarget).data('userid');
      this.moveToInvited(userId, event.currentTarget);
      if (this.model.iAmGuide()) {
        this.socket.inviteAsTourGuest(userId);
      }
      this.model.info("success", "Invitation sent");
    });

    this.closeButton = this.wrapper.find("#userToTourInviteButton");
    this.closeButton.on("click", () => {
      this.close();
    });
  }
}
